import { SocialCode, SocialsSetting } from '@/types/socialDistribution'

export const socialNet = {
  vk: 'Вконтакте',
  ok: 'Одноклассники',
  tt: 'TikTok',
  yt: 'YouTube',
  tg: 'Телеграм',
  zn: 'Дзен',
}

export const socialsSetting: Partial<Record<SocialCode, SocialsSetting>> = {
  vk: {
    max_symbol: 4000,
    multiple_photos: true,
    gallery: true,
    video: true,
    editorToolbar: [['EmojiPanel']],
  },
  tg: {
    max_symbol: 4000,
    multiple_photos: true,
    gallery: true,
    video: true,
    editorToolbar: [
      ['Format'],
      ['Bold', 'Italic', 'Strike', 'Cite', 'RemoveFormat'],
      ['NumberedList', 'BulletedList'],
      ['Link', 'Unlink'],
      ['EmojiPanel'],
    ],
  },
  ok: {
    max_symbol: 4000,
    multiple_photos: true,
    gallery: true,
    video: true,
    editorToolbar: [['EmojiPanel']],
  },
  viber: {
    max_symbol: 768,
    multiple_photos: false,
    gallery: false,
    video: true,
    editorToolbar: [['EmojiPanel']],
  },
  fb: {
    max_symbol: 4000,
    multiple_photos: false,
    gallery: false,
    video: false,
    editorToolbar: [['EmojiPanel']],
  },
  twitter: {
    max_symbol: 280,
    multiple_photos: false,
    gallery: false,
    video: false,
    editorToolbar: [['EmojiPanel']],
  },
}
